import React from "react";

import { useTranslation } from "react-i18next";

import { ThreeWay } from "@data-types/sport-stats/SportStatsTypes";

import Graph from "../Graph";
import SegmentedGraph from "../SegmentedGraph";

interface IThreeWayStatisticsProps {
	homeTeam: ThreeWay["data"];
	awayTeam: ThreeWay["data"];
}

export default function ThreeWayStatistics(props: IThreeWayStatisticsProps) {
	const { t } = useTranslation();

	return (
		<>
			<SegmentedGraph
				title={t("EVENT.STATISTICS.BETTING_TYPE_STATS.WIN_PROBABILITY")}
				data={{
					homeValue: props.homeTeam?.homeWinProbability,
					drawValue: props.homeTeam?.drawProbability,
					awayValue: props.homeTeam?.homeLossProbability,
				}}
				isPercentage
			/>
			<div className="card card--raised card--raised--framed card--stats">
				<div className="card--stats__body">
					<Graph
						home={t("EVENT.OFFER.COMPETITOR_HOME")}
						away={t("EVENT.OFFER.COMPETITOR_AWAY")}
						graphName={t("EVENT.STATISTICS.RECENT_FORM")}
						data={{
							homeValue: props.homeTeam?.recentFormPercentage,
							awayValue: props.awayTeam?.recentFormPercentage,
						}}
						isPercentage
						noBorder
					/>

					<LastFiveGames
						homeTeam={props.homeTeam}
						awayTeam={props.awayTeam}
					/>
				</div>
			</div>
		</>
	);
}

const LastFiveGames = (props: IThreeWayStatisticsProps) => {
	const { t } = useTranslation();

	const isHomeTeamAvailable = props.homeTeam?.recentForm?.some(
		(item) => item !== ""
	);

	const isAwayTeamAvailable = props.awayTeam?.recentForm?.some(
		(item) => item !== ""
	);

	if (!isAwayTeamAvailable && !isHomeTeamAvailable) {
		console.error("recentForm for both teams is null.");
		return null;
	}

	return (
		<>
			<div className="card--stats__row u-gap--2">
				<div className="card--stats__col card--stats__col--left">
					{isHomeTeamAvailable && (
						<div className="stats--scores">
							{props.homeTeam?.recentForm?.map((form) => {
								return <StatsItem stats={form} />;
							})}
						</div>
					)}
				</div>

				<div className="card--stats__col card--stats__col--middle">
					<div className="card--stats__label u-type--xxsml">
						{t("EVENT.STATISTICS.BETTING_TYPE_STATS.LAST_FIVE")}
					</div>
				</div>

				<div className="card--stats__col card--stats__col--right">
					{isAwayTeamAvailable && (
						<div className="stats--scores">
							{props.awayTeam?.recentForm?.map((form) => {
								return <StatsItem stats={form} />;
							})}
						</div>
					)}
				</div>
			</div>
		</>
	);
};

const StatsItem = ({ stats }: { stats: string }) => {
	let statsType = "";

	switch (stats) {
		case "W":
			statsType = "win";
			break;
		case "L":
			statsType = "lose";
			break;
		case "D":
			statsType = "draw";
			break;
		default:
			break;
	}

	return (
		<div className={`stats--scores__box stats--scores__box--${statsType}`}>
			{stats}
		</div>
	);
};
